import React from 'react';
import { Modal, Image, Button } from 'antd';
import balanceTipIcon from '../../../assets/images/home/balance-tip.png';
import safeIcon from '../../../assets/images/safe.png';
import safeShieldIcon from '../../../assets/images/safe-sheild.png';
import integrityReportImg from '../../../assets/images/home/integrity-report.JPEG';

const IntegrityReportModal = ({ visible, onClose }) => {
  return (
    <Modal
      visible={visible}
      footer={null}
      onCancel={onClose}
      title="廉政举报"
      width={540}
      closable={true}
      className="integrity-report-modal"
      centered
      maskClosable
    >
        <img src={balanceTipIcon} alt="balance" className="integrity-report-modal-balance" />
        <div className="integrity-report-modal-content">
          <div className="integrity-report-modal-tip">
            <img src={safeIcon} className="tip-icon" alt="safe" />
            <span>您可通过下列任一渠道提交举报信息，<b>我们将严格对举报人身份、举报内容及调查过程实行全流程保密！</b></span>
          </div>
          <div className="integrity-report-modal-tip">
            <img src={safeShieldIcon} className="tip-icon" alt="safe-shield" />
            <span><b>如举报内容经我司调查属实，我们将根据线索价值酌情给予奖励，</b>感谢您对公司治理的关注与支持。</span>
          </div>
          <div className="integrity-methods-content">
            <div><b>举报方式：</b></div>
            <div className="integrity-report-modal-method"><span className="method-list">渠道一：</span>廉政举报邮箱 <a href="mailto:zzsx@shiyanjia.com" style={{color:'#1890ff'}}>zzsx@shiyanjia.com</a></div>
            <div className="integrity-report-modal-method"><span className="method-list">渠道二：</span>廉政举报手机/微信 <a href="tel:19106781396" style={{color:'#1890ff'}}>19106781396</a></div>
            <div className="integrity-report-modal-method"><span className="method-list">渠道三：</span>廉政举报表单（请扫描下方二维码填写）</div>
            <div className="integrity-report-modal-img">
              <Image width={160} src={integrityReportImg} preview={false} />
            </div>
          </div>
          <div className="integrity-report-modal-btn">
            <Button type="primary" onClick={onClose} >我知道了</Button>
          </div>
        </div>
    </Modal>
  );
};

export default IntegrityReportModal;
